import React from 'react';
export const defaultDisclosureItemContext = {
    open: false,
    toggleOpen: () => { },
};
export const DisclosureItemContext = React.createContext(defaultDisclosureItemContext);
//# sourceMappingURL=disclosureItem.context.js.map